import { render } from "./ContractsTable.vue?vue&type=template&id=3e2a5964"
import script from "./ContractsTable.vue?vue&type=script&lang=js"
export * from "./ContractsTable.vue?vue&type=script&lang=js"

import "./ContractsTable.vue?vue&type=style&index=0&id=3e2a5964&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__